define('sortByConfig',["searchTypeHelper", "i18n!nls/res"], function (searchTypeHelper, res) {
    "use strict";

    var customOptions = {
        default: res["default"],
        priceLowHigh: res["priceLowHigh"],
        priceHighLow: res["priceHighLow"],
        builderAToZ: res["builderAToZ"],
        builderZToA: res["builderZToA"]
    };

    var communitiesOptions = {
        default: res["default"],
        matchingHomes: res["matchingHomes"],
        cityAToZ: res["cityAToZ"],
        cityZToA: res["cityZToA"],
        priceLowHigh: res["priceLowHigh"],
        priceHighLow: res["priceHighLow"],
        builderAToZ: res["builderAToZ"],
        builderZToA: res["builderZToA"],
        communityAToZ: res["communityAToZ"],
        communityZToA: res["communityZToA"]
    };

    var homesOptions = {
        default: res["default"],
        cityAToZ: res["cityAToZ"],
        cityZToA: res["cityZToA"],
        priceLowHigh: res["priceLowHigh"],
        priceHighLow: res["priceHighLow"],
        bedroomsHighLow: res["bedroomsHighLow"],
        bedroomsLowHigh: res["bedroomsLowHigh"],
        builderAToZ: res["builderAToZ"],
        builderZToA: res["builderZToA"],
        planNameAToZ: res["planNameAToZ"],
        planNameZToA: res["planNameZToA"]
    };

    function getSortOptionsForCurrentPage(srpType) {
        var options = {};

        if (searchTypeHelper.isAnyHomeSearchType(srpType)) {
            options = homesOptions;
        }

        if (searchTypeHelper.isAnyCommunitySearchType(srpType)) {
            options = communitiesOptions;
        }

        if (searchTypeHelper.isCustomBuilderSearchType(srpType)) {
            options = customOptions;
        }

        return options;
    }

    function isValidSortOption(srpType, value) {
        var options = getSortOptionsForCurrentPage(srpType);
        return options.hasOwnProperty(value);
    }

    return {
        getSortOptions: getSortOptionsForCurrentPage,
        isValid: isValidSortOption
    };
});
